import { Pipe, PipeTransform } from '@angular/core';
import { Organizacja } from '../models/organizacja';

@Pipe({
  name: 'organizationDescription',
  standalone: true,
})
export class OrganizationDescriptionPipe implements PipeTransform {
  transform(organization: Organizacja): string {
    if (!organization) return '';
    if (organization.nip) {
      return 'NIP: ' + organization.nip;
    }
    if (organization.regon) {
      return 'REGON: ' + organization.regon;
    }
    if (organization.pesel) {
      return 'PESEL: ' + organization.pesel;
    }
    return '';
  }
}
